import { render, staticRenderFns } from "./Ezb.vue?vue&type=template&id=ca53cc42&scoped=true&"
import script from "./Ezb.vue?vue&type=script&lang=js&"
export * from "./Ezb.vue?vue&type=script&lang=js&"
import style0 from "./Ezb.vue?vue&type=style&index=0&id=ca53cc42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca53cc42",
  null
  
)

export default component.exports